import React, { useState } from "react";
import {
  Input,
  Form,
  Button,
  Upload,
  Select,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../common";
import "./Feedback.scss";
import { PlusOutlined, DeleteOutlined, FilePdfOutlined } from "@ant-design/icons";
import { postRequest } from "../../api/http";
import { toast } from "react-toastify";
import backArrow from "../../assets/images/back-arrow.svg";

function FeedBack() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState(null);
  const [fileSizeOk, setFileSizeOk] = useState(false);

  const checkFile = (file) => {
    const maxSize = 2.5 * 1024 * 1024;
    const isSizeValid = file.size <= maxSize;
    const isImageOrPdf = file.type.startsWith('image/') || file.type === 'application/pdf';

    if (!isImageOrPdf) {
      toast.error("You can only upload image or PDF files!");
      return false;
    }

    if (!isSizeValid) {
      setFileSizeOk(false);
      toast.error("File size exceeds 2.5MB!");
      return false;
    } else {
      setFileSizeOk(true);
    }

    // Create preview for images
    if (file.type.startsWith('image/')) {
      file.thumbUrl = URL.createObjectURL(file);
    }

    return isSizeValid && isImageOrPdf;
  };

  const onFinish = async (values) => {
    try {
      if (file) {
        if (fileSizeOk) {
          setLoading(true);
          if (values && values.message && values.feedbackAboutEnum) {
            var formData = new FormData();
            if (file) {
              formData.append("file", file, fileName);
            }
            const formatedData = {
              feedbackAboutEnum: values.feedbackAboutEnum,
              message: values.message,
              organizationId: localStorage.getItem("OrgId"),
              userRole: "ORGANIZATION_ADMIN"
            };
            const json = JSON.stringify(formatedData);
            const blob = new Blob([json], {
              type: "application/json",
            });
            formData.append("supportAndFeedbackInput", blob);
            const response = await postRequest(
              userServiceApi.feedbackForm(),
              formData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            if (response) {
              setFileName(null);
              setFileList([]);
              setFile(null);
              toast.success("Feedback sent successfully");
              setFileSizeOk(false);
              setLoading(false);
              form.resetFields();
            }
          }
        } else {
          toast.error("File size exceeds 2.5MB!");
        }
      } else {
        setLoading(true);
        if (values && values.message && values.feedbackAboutEnum) {
          var feedbackFormData = new FormData();
          const formatedData = {
            feedbackAboutEnum: values.feedbackAboutEnum,
            message: values.message,
            organizationId: localStorage.getItem("OrgId"),
            userRole: "ORGANIZATION_ADMIN"
          };
          const json = JSON.stringify(formatedData);
          const blob = new Blob([json], {
            type: "application/json",
          });
          feedbackFormData.append("supportAndFeedbackInput", blob);
          const response = await postRequest(
            userServiceApi.feedbackForm(),
            feedbackFormData,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response) {
            toast.success("Feedback sent successfully");
            setLoading(false);
            form.resetFields();
          }
        }
      }
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  const handleUploadAPI = ({ file }) => {
    const fileName = file.name;
    setFileName(fileName);

    const blob = new Blob([file], {
      type: "multipart/form-data",
    });
    setFile(blob);

    // Add file to fileList for preview
    if (Object.values(fileList).length === 0) {
      setFileList([file]);
    }
  };

  const handleRemoveFile = () => {
    // Revoke object URL to avoid memory leaks
    if (fileList[0]?.thumbUrl) {
      URL.revokeObjectURL(fileList[0].thumbUrl);
    }

    setFileList([]);
    setFile(null);
    setFileName(null);
    setFileSizeOk(false);
  };

  const uploadProps = {
    accept: ".pdf, .jpeg, .png, .jpg",
    beforeUpload: checkFile,
    maxCount: 1,
    multiple: false,
    showUploadList: false,
    customRequest: handleUploadAPI,
  };

  if (loading) return <LoadingView message="Loading..." />;

  return (
    <>
      <div className="tabContainer">
        <div className="page-header">
          <div className="backbtn-container">
            <img src={backArrow} alt="" onClick={() => navigate('/')} />
            <p>Support & Feedback</p>
          </div>
        </div>
        <div style={{ padding: "10px" }}>
          <div className="formInfoStyle">
            <Form
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 10 }}
              onFinish={onFinish}
              autoComplete="off"
              form={form}
            >
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    label="I want to"
                    name="feedbackAboutEnum"
                    rules={[
                      {
                        required: true,
                        message: "Feedback type is required",
                      },
                    ]}
                  >
                    <Select
                      name="feedbackAboutEnum"
                      placeholder="I want to.."
                    >
                      <Select.Option value="COMMENT">
                        Leave a comment
                      </Select.Option>
                      <Select.Option value="REPORT">
                        Report a bug
                      </Select.Option>
                      <Select.Option value="SUGGESTION">
                        Suggest an improvement
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "Feedback message is required",
                      },
                    ]}
                    label="Message"
                    name="message"
                  >
                    <Input.TextArea
                      rows={3}
                      maxLength={700}
                      showCount
                      placeholder="Message"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="doc"
                    label="Feedback document"
                    name="feedbackDocument"
                  >
                    <Tooltip title="Please upload a image or PDF with size less than 5MB.">
                      <Upload {...uploadProps}>
                        {fileList.length === 0 ? (
                          <div className="uploadBox">
                            <PlusOutlined />
                            <div className="uploadText">No document uploaded</div>
                          </div>
                        ) : (
                          <div style={{ display: 'none' }}>
                            {/* Hidden upload trigger */}
                          </div>
                        )}
                      </Upload>
                    </Tooltip>

                    {/* File Preview Section */}
                    {fileList.length > 0 && (
                      <div className="file-previews">
                        {fileList.map(file => (
                          <div key={file.uid} className="file-preview-item" style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '12px',
                            border: '1px solid #d9d9d9',
                            borderRadius: '6px',
                            marginBottom: '8px',
                            backgroundColor: '#fafafa'
                          }}>
                            {/* Image Preview */}
                            {file.type?.startsWith('image/') ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
                                <img
                                  src={file.thumbUrl}
                                  alt="Preview"
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    objectFit: 'cover',
                                    borderRadius: '4px'
                                  }}
                                />
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontWeight: '500', fontSize: '14px' }}>
                                    {file.name}
                                  </div>
                                  <div style={{ fontSize: '12px', color: '#666' }}>
                                    {(file.size / 1024 / 1024).toFixed(2)} MB
                                  </div>
                                </div>
                                <Button
                                  type="text"
                                  danger
                                  size="small"
                                  icon={<DeleteOutlined />}
                                  onClick={handleRemoveFile}
                                >
                                  Remove
                                </Button>
                              </div>
                            ) : (
                              /* PDF/Document Preview */
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
                                <FilePdfOutlined
                                  style={{
                                    fontSize: '32px',
                                    color: '#ff4d4f'
                                  }}
                                />
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontWeight: '500', fontSize: '14px' }}>
                                    {file.name}
                                  </div>
                                  <div style={{ fontSize: '12px', color: '#666' }}>
                                    {(file.size / 1024 / 1024).toFixed(2)} MB
                                  </div>
                                </div>
                                <Button
                                  type="text"
                                  danger
                                  size="small"
                                  icon={<DeleteOutlined />}
                                  onClick={handleRemoveFile}
                                >
                                  Remove
                                </Button>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Form.Item>
                </div>
              </div>
            </Form>
            <div className="formInfoRow">
              <div className="formInfoCol">
                <div className="form-btn-container" style={{ display: 'flex', justifyContent: 'end' }}>
                  <Button className="sendBtn greenBtn" htmlType="submit" onClick={() => form.submit()}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeedBack;